import React, { useState, useEffect } from "react";
import axios from "axios";

const QuizManagement = () => {
    const [quizzes, setQuizzes] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedQuiz, setSelectedQuiz] = useState(null);

    useEffect(() => {
        // Fetch quizzes from the new admin endpoint as JSON objects
        axios
            .get("http://localhost:8000/api/admin/quizzes")
            .then((res) => {
                setQuizzes(res.data.quizzes || []);
            })
            .catch((err) => console.error("Error loading quizzes", err));
    }, []);

    const handleEditQuiz = (quiz) => {
        axios
            .patch("http://localhost:8000/api/admin/quizzes/" + quiz._id, quiz)
            .then(() => {
                // Optionally refresh quizzes list after edit.
            })
            .catch((err) => console.error("Error editing quiz", err));
    };

    const handleDeleteQuiz = (quizId) => {
        if (window.confirm("Are you sure you want to delete this quiz?")) {
            axios
                .delete(`http://localhost:8000/api/admin/quizzes/${quizId}`)
                .then(() => {
                    setQuizzes(quizzes.filter((q) => q._id !== quizId));
                })
                .catch((err) => console.error("Delete error", err));
        }
    };

    const handleEdit = (quiz) => {
        setSelectedQuiz(quiz);
        setShowModal(true);
    };

    return (
        <div>
            <h2 className="text-2xl font-semibold text-gray-700 mb-4">Quiz Management</h2>
            {quizzes.length === 0 ? (
                <p className="text-gray-500">No quizzes found.</p>
            ) : (
                <table className="min-w-full border border-gray-300">
                    <thead className="bg-gray-200">
                        <tr>
                            <th className="py-2 px-4 border">ID</th>
                            <th className="py-2 px-4 border">Title</th>
                            <th className="py-2 px-4 border">Action</th>
                            <th className="py-2 px-4 border">Edit</th>
                            <th className="py-2 px-4 border">Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        {quizzes.map((quiz) => (
                            <tr key={quiz._id} className="hover:bg-gray-100">
                                <td className="py-2 px-4 border">{quiz._id}</td>
                                <td className="py-2 px-4 border">{quiz.title}</td>
                                <td className="py-2 px-4 border">
                                    <button
                                        className="px-3 py-1 bg-indigo-600 text-white rounded hover:bg-indigo-700"
                                        onClick={() => handleEdit(quiz)}
                                    >
                                        Edit
                                    </button>
                                </td>
                                <td className="py-2 px-4 border">
                                    <button
                                        onClick={() => handleEditQuiz(quiz)}
                                        className="text-blue-600 hover:underline"
                                    >
                                        Edit
                                    </button>
                                </td>
                                <td className="py-2 px-4 border">
                                    <button
                                        onClick={() => handleDeleteQuiz(quiz._id)}
                                        className="text-red-600 hover:underline"
                                    >
                                        Delete
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
            {showModal && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white p-6 rounded-md shadow-lg w-1/2">
                        <h3 className="text-xl font-bold mb-4">
                            Edit Quiz: {selectedQuiz.title}
                        </h3>
                        <form>
                            <div className="mb-4">
                                <label className="block text-gray-700">Quiz Title</label>
                                <input
                                    type="text"
                                    defaultValue={selectedQuiz.title}
                                    className="w-full border px-3 py-2 rounded"
                                />
                            </div>
                            {/* Add additional fields as needed */}
                            <div className="flex justify-end">
                                <button
                                    type="submit"
                                    className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
                                >
                                    Save Changes
                                </button>
                                <button
                                    type="button"
                                    className="ml-4 px-4 py-2 bg-gray-400 text-white rounded hover:bg-gray-500"
                                    onClick={() => setShowModal(false)}
                                >
                                    Cancel
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default QuizManagement;